var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTryThisVoice = function SvgIconTryThisVoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_try_this_voice_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 4.474v5.052m-1.895-3.79v2.527M3.211 6.368v1.264m5.684-1.895v2.526m1.895-1.895v1.264M1 7c0-2.828 0-4.243.879-5.121C2.757 1 4.17 1 7 1c2.828 0 4.243 0 5.121.879C13 2.757 13 4.17 13 7c0 2.828 0 4.243-.879 5.121C11.244 13 9.83 13 7 13c-2.828 0-4.243 0-5.121-.879C1 11.244 1 9.83 1 7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_try_this_voice_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgIconTryThisVoice;